import React, { Component } from "react";
import TopNavBarNew from "../../Components/TopNavBarNew";
import BottomNavBarNew from "../../Components/BottomNavBarNew";
import FlexibleCard from "../../Components/FlexibleCard";
import styles from "./PrivacyTermsOfUse.module.css";

export class PrivacyPolicyMore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageContent: {},
      appLanguage: this.props.appLanguage || localStorage.getItem("language") || "en", // Ensure appLanguage is always available
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Privacy Policy";
    this.loadPageData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.appLanguage !== this.props.appLanguage) {
      this.setState(
        { appLanguage: this.props.appLanguage || localStorage.getItem("language") || "en" },
        this.loadPageData
      );
    }
  }

  loadPageData() {
    const { appLanguage } = this.state;

    const entries = JSON.parse(localStorage.getItem("ayaAppEntries") || "[]");

    const getEntryById = (id) => entries.find((entry) => entry.sys.id === id);
    const getField = (entry, fieldName, locale) =>
      entry?.fields?.[fieldName]?.[locale] || entry?.fields?.[fieldName]?.["en"] || "";

    const pageEntry = getEntryById("3NSFOsEsJ2Lihkwabs1eyl");

    const pageContent = {
      title: getField(pageEntry, "largeCardTitle1", appLanguage) || "Sobre Vitala",
      description: getField(pageEntry, "largeCardDescription1", appLanguage) || "",
    };

    this.setState({ pageContent });
  }

  render() {
    const { pageContent, appLanguage } = this.state;

    return (
      <div className={styles.container}>
        {/* Top Navbar with Title */}
        <TopNavBarNew pageTitle={pageContent.title} />

        <div className={styles.extraSpace}></div>

        {/* White Card */}
{/*         <div className={styles.card}>
          <p className={styles.cardText}>{pageContent.description}</p>
        </div>
        <div className={styles.bottomSpace}></div> */}
        <FlexibleCard
          description={pageContent.description}
          width="351px"
          borderRadius="10px"
        />
        <div className={styles.bottomSpace}></div>

        {/* Bottom Nav Bar with appLanguage */}
        <BottomNavBarNew appLanguage={appLanguage} />
      </div>
    );
  }
}

export default PrivacyPolicyMore;